// extracted by mini-css-extract-plugin
export default {"srOnly":"PasswordFieldView_srOnly__dfSOY"};